import React from 'react'

export default class StatsTable extends React.Component {
  render() {
    const { stats } = this.props

    return (
      <div className="stats-table">
        {stats &&
          stats instanceof Array &&
          stats.map(({ label, sublabel, value, rank, highlight }, idx) => (
            <div className={`line ${highlight && 'highlight'}`} key={idx}>
              {rank && idx > 0 && rank !== this.props.stats[idx - 1].rank + 1 && (
                <div className="rank-divide" />
              )}
              {rank && <div className="rank">{`${rank}.`}</div>}
              <label>
                {label}
                <div className="sublabel">{sublabel}</div>
              </label>
              {rank === 1 && (
                <img
                  src={require('../images/icon_leader.png')}
                  alt="leader"
                  style={{ width: 18, height: 18, marginRight: 10 }}
                />
              )}
              <div className="value">{value ? value.toLocaleString() : 0}</div>
            </div>
          ))}
      </div>
    )
  }
}
